import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TitleH3 from "./titleH3";
import HorizontalAlign from "./horizontalAlign";
import Container from "./container";
import Button from "./button";
import VerticalAlign from "./verticalAlign";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
}));

function getSteps() {
    return ['Type de licence', 'Informations du licencié', 'Récapitulatif', 'Paiement'];
}

const VerticalLinearStepper = ({getStepContent = null, dispatch = null}) => {
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        dispatch()
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        getStepContent !== null ?
            <HorizontalAlign>
                <Container width="75%">
                    <Stepper activeStep={activeStep} orientation="vertical">
                        {steps.map((label, index) => (
                            <Step key={label}>
                                <StepLabel>
                                    <TitleH3 marginBottom="0" marginTop="0">{label}</TitleH3>
                                </StepLabel>
                                <StepContent>
                                    <div>{getStepContent(index)}</div>
                                </StepContent>
                            </Step>
                        ))}
                    </Stepper>
                </Container>
                <HorizontalAlign width="25%" justifyContent="flex-end">
                    <VerticalAlign alignItems="flex-end">
                        <div>
                            {activeStep === 0 ? null :
                                <Button width="auto" marginTop="0" inverted={true} value="" onClick={handleBack}>
                                    Précédent
                                </Button>
                            }
                            {activeStep === steps.length - 1 ? null :
                                <Button width="auto" marginTop="0" value="" onClick={handleNext}>Suivant</Button>
                            }
                        </div>
                        <div>
                            {activeStep === 0 ? null :
                                <Button width="auto" marginTop="0" inverted={true} value="" onClick={handleBack}>
                                    Précédent
                                </Button>
                            }
                            {activeStep === steps.length - 1 ? null :
                                <Button width="auto" marginTop="0" value="" onClick={handleNext}>Suivant</Button>
                            }
                        </div>
                    </VerticalAlign>
                </HorizontalAlign>
                {activeStep === steps.length && (
                    <Paper square elevation={0} className={classes.resetContainer}>
                        <Typography>All steps completed - you&apos;re finished</Typography>
                        <Button onClick={handleReset} className={classes.button}>
                            Reset
                        </Button>
                    </Paper>
                )}
            </HorizontalAlign>
            : null
    );
}

export default VerticalLinearStepper
